import { apiInstance } from '../api';

// an employee's own settings, kept on the server (backend service/userSettings.service.js)
export class UserSettingsService {
  // { value }, null when nothing is saved yet
  static async get(key) {
    return apiInstance.get(`/user-settings/${key}`)
  }

  static async set(key, value) {
    return apiInstance.put(`/user-settings/${key}`, { value })
  }
}
